import React from "react";
import { Col, Container, Row } from "react-bootstrap";

import SocialMediaButton from "./socialMediaButton";

import BiggyImage from "../../assets/biggy_pointing.png";
import cloudFooterImage from "../../assets/logo_footer.svg";

import {
  FaTelegramPlane,
  // FaReddit,
  FaMediumM,
  FaTwitter,
  FaYoutube,
  FaDiscord,
  FaInstagram,
} from "react-icons/fa";

import appleStoreImage from "../../assets/apple_store.png";
import playStoreImage from "../../assets/play_store.png";
import windowsStoreImage from "../../assets/windows_store.png";
import macosStoreImage from "../../assets/macOS_store.png";

import "./footerStyles.css";

const TELEGRAM_URL = "https://t.me/Geopoly_Game";
// const REDDIT_URL = "https://www.reddit.com/r/GEOPOLY";
const MEDIUM_URL = "https://geopoly.medium.com";
const TWITTER_URL = "https://twitter.com/Geopoly_Game";
const YOUTUBE_URL = "https://www.youtube.com/channel/UC8wAdUp3c5ymz1FFepD9ZsA";
const DISCORD_URL = "https://discord.gg/99aPX2qF39";
const INSTAGRAM_URL = "https://www.instagram.com/geopoly_game";
const PLAYSTORE_URL =
  "https://play.google.com/store/apps/details?id=com.widowgames.geopoly&hl=es_AR";
const APPLESTORE_URL = "https://apps.apple.com/ar/app/geopoly/id417575532";
const WINDOWS_URL = "https://dl.patchkit.net/d/42a9ynoe13wi6n4i9rma/direct";
const MACOS_URL = "https://geopoly.io/builds/macos.dmg";

const Footer = () => {
  return (
    <Container fluid className="footer">
      <Row>
        <img className="w-100" src={cloudFooterImage} alt="cloud" />
      </Row>
      <Row className="footer-social align-items-center">
        <Col xs={12} md={6} className="text-center">
          <img className="footer-social-biggy" src={BiggyImage} alt="Biggy" />
        </Col>
        <Col xs={12} md={6}>
          <Row>
            <Col xs={12} lg={10} xl={9}>
              <h1>
                Join <span className="yellow">US!</span>
              </h1>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col xs={12} lg={10} xl={9}>
              <p>Follow us on all our networks to find out the latest news!</p>
            </Col>
          </Row>
          <Row className="mb-4">
            <Col xs={12} lg={10} xl={9}>
              <Row className="footer-media align-items-center">
                <SocialMediaButton
                  styles="telegram"
                  link={TELEGRAM_URL}
                  logo={<FaTelegramPlane className="logo" />}
                />
                {/* <SocialMediaButton
                  styles="reddit"
                  link={REDDIT_URL}
                  logo={<FaReddit className="logo" />}
                /> */}
                <SocialMediaButton
                  styles="medium"
                  link={MEDIUM_URL}
                  logo={<FaMediumM className="logo" />}
                />
                <SocialMediaButton
                  styles="twitter"
                  link={TWITTER_URL}
                  logo={<FaTwitter className="logo" />}
                />
                <SocialMediaButton
                  styles="youtube"
                  link={YOUTUBE_URL}
                  logo={<FaYoutube className="logo" />}
                />
                <SocialMediaButton
                  styles="discord"
                  link={DISCORD_URL}
                  logo={<FaDiscord className="logo" />}
                />
                <SocialMediaButton
                  styles="instagram"
                  link={INSTAGRAM_URL}
                  logo={<FaInstagram className="logo" />}
                />
              </Row>
            </Col>
          </Row>
          <Row className="footer-stores">
            <Col xs={4} md={5} lg={4} className="px-1">
              <a href={PLAYSTORE_URL} target="_blank" rel="noopener noreferrer">
                <img src={playStoreImage} alt="PlayStore" />
              </a>
            </Col>
            <Col xs={4} md={5} lg={4} className="px-1">
              <a
                href={APPLESTORE_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={appleStoreImage} alt="AppleStore" />
              </a>
            </Col>
          </Row>
          <Row className="footer-stores mt-2">
            <Col xs={4} md={5} lg={4} className="px-1">
              <a href={WINDOWS_URL} target="_blank" rel="noopener noreferrer">
                <img src={windowsStoreImage} alt="Windows" />
              </a>
            </Col>
            <Col xs={4} md={5} lg={4} className="px-1">
              <a href={MACOS_URL} target="_blank" rel="noopener noreferrer">
                <img src={macosStoreImage} alt="Mac OS" />
              </a>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="footer-trademark justify-content-center">
        <Col xs={11}>
          <h3 className="text-center mx-auto">
            © 2022 - GEOPOLY™ and Widow Games™ are trademarks registered by
            Widow Games LLC. All rights reserved.
          </h3>
        </Col>
      </Row>
    </Container>
  );
};

export default Footer;
